import { render, staticRenderFns } from "./ModalCompanyLandingPage.vue?vue&type=template&id=4185ba7e"
import script from "./ModalCompanyLandingPage.vue?vue&type=script&lang=js"
export * from "./ModalCompanyLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports